import {
  CartItemTypes,
  ICartItemType,
  ICartItem_Product,
} from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import {
  ICommonProductDetails,
  IProductAddOn,
} from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import { IAddOnWithQuantity, IAddons } from "./interfaces";
import { addonsInitValues } from "@/app/components/common-addons-builder/addon-functions";

type getProductFromCartReturnType = {
  quantity: number;
  selectedAddons: any;
  note: string;
  addedToCart: boolean;
  other_inputs: object;
  unit_id?: number;
  price?: number;
};

export const getProductFromCart = (
  cartItems: ICartItemType[],
  product: ICommonProductDetails,
  show_all_product_units: boolean,
  cartItemID?: number,
): getProductFromCartReturnType => {
  const initAddOns = (addons_builder: any[]) => {
    if (!addons_builder || addons_builder?.length === 0) return {};
    return addons_builder?.reduce(
      (acc, addOn) => ({ ...acc, [addOn.configurations.key]: [] }),
      {},
    );
  };
  // if (!cartItems) return null;
  const index = (cartItems ?? [])?.findIndex(
    (item) => item.inner_id === product?.id && item.id === cartItemID,
  );
  if (index < 0)
    return {
      quantity: product.min_quantity_in_cart ?? 1,
      selectedAddons: initAddOns(product?.addons_builder),
      note: "",
      addedToCart: false,
      other_inputs: {},
      unit_id: show_all_product_units ? product.units[0]?.id : product.unit_id,
    };
  if (cartItems[index].type === CartItemTypes.product) {
    return {
      quantity: cartItems[index].quantity,
      selectedAddons: addonsInitValues(cartItems[index].addons),
      note: cartItems[index].note,
      addedToCart: true,
      other_inputs: { ...cartItems[index]?.others?.data_fields },
      unit_id:
        (cartItems[index] as ICartItem_Product).others.unit_id ??
        product.unit_id,
      price: cartItems[index].price,
    };
  }
  return {
    quantity: cartItems[index].quantity,
    selectedAddons: addonsInitValues(cartItems[index].addons),
    note: cartItems[index].note,
    addedToCart: true,
    other_inputs: { ...cartItems[index]?.others?.data_fields },
    price: cartItems[index].price,
  };
};

export const isRequiredAddonsNotChoosed = (
  addons: IProductAddOn[],
  selectedAddons: IAddons,
) => {
  for (let i = 0; i < addons?.length; i++) {
    const selectedAddon = selectedAddons[addons[i]?.configurations.key];
    const selectedAddonQuantity =
      selectedAddon?.reduce((prev, current) => prev + current.quantity, 0) ?? 0;
    const selectedAddonMinQuantity = addons[i].configurations.min_quantity ?? 0;
    if (
      addons[i].configurations.is_required &&
      (!selectedAddon ||
        selectedAddon.length === 0 ||
        selectedAddonQuantity < selectedAddonMinQuantity)
    )
      return true;
  }
  return false;
};

export const getSelectedAddOnsPrice = (
  allAddons: IProductAddOn[],
  selectedAddons: IAddOnWithQuantity[],
) => {
  const flatAddons = allAddons.map((addon) => addon.data).flat();
  const flatcurrentAddons = selectedAddons.flat();
  let currentAddonsPrice = 0;
  for (let i = 0; i < flatcurrentAddons.length; i++)
    currentAddonsPrice +=
      (flatAddons.find((addon) => addon.id === flatcurrentAddons[i].id)
        ?.price ?? 0) * flatcurrentAddons[i].quantity;
  return currentAddonsPrice;
};

export function compareAddOnsArrays(
  arr1: IAddOnWithQuantity[],
  arr2: IAddOnWithQuantity[],
  withQuantities?: boolean,
): boolean {
  if (arr1.length !== arr2.length) {
    return false;
  }
  if (!arr1.length && !arr2.length) return true;

  // Sort both arrays by `id` (and optionally by `quantity` if needed)
  const sortedArr1 = arr1.slice().sort((a, b) => a.id - b.id);
  const sortedArr2 = arr2.slice().sort((a, b) => a.id - b.id);

  // Compare each object in the sorted arrays
  for (let i = 0; i < sortedArr1.length; i++) {
    if (
      sortedArr1[i].id !== sortedArr2[i].id ||
      (withQuantities && sortedArr1[i].quantity !== sortedArr2[i].quantity)
    ) {
      return false;
    }
  }

  // If all objects match, return true
  return true;
}
